import { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { ReportingContext } from "../home/home";
import { useStore } from "../../hooks-store/store";
import { getReportingLinks } from "./links";
import { sendCallToAPI } from "../../common/generic_functions";
import { PowerBIEmbed } from "powerbi-client-react";
import { LoadingScreen } from "../../components_new/loadingspinner/loading-screen";
import "./dashboard.sass";
import { embedConfiguration, eventHandlerReports } from "./components/reports-powerbi-function";


export const Dashboard = () => {
  const { workspaceId, reportingId } = useParams();
  const [embedConfig, setEmbedConfig] = useState();
  const { setCurrentWorkSpace, changeDesignObject, setReportingExpirationTime, setReportName, setCurrentWorkSpaceName } = useContext(ReportingContext);
  const [loading, setLoading] = useState(true);
  const reportingInstance = useRef();
  const [store] = useStore();

  useEffect(() => {
    setCurrentWorkSpace(workspaceId ?? "");
    loadReports();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceId]);

  const loadReports = async () => {
    try {
      if (workspaceId === "test-workspace-1") {
        changeDesignObject({ component: "SHIP" });
      } else {
        changeDesignObject();
      }
      const link = `${getReportingLinks("singeReport")}${reportingId}/`;
      let embedConfig = await sendCallToAPI(link, store.accessToken);
      if (embedConfig["message"]) {
        throw new Error("Error!");
      }
      setReportingExpirationTime(embedConfig["tokenExpiry"]);
      setReportName(embedConfig["reportName"]);
      setCurrentWorkSpaceName(embedConfig["workspace"]);
      setEmbedConfig(embedConfig);
    } catch {
      setLoading(false);
    }
  };


  useEffect(() => {
    setCurrentWorkSpace(workspaceId ?? "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportingId]);

  useEffect(() => {
    return () => {
      setReportingExpirationTime();
      setReportName();
    };
  }, []);


  return (
    <>
      <LoadingScreen loading={loading} />
      {embedConfig && (
        <div style={{ display: loading ? "none" : "unset" }}>
          <PowerBIEmbed
            embedConfig={embedConfiguration(embedConfig) }
            cssClassName={"power-bi-embed-window"}
            eventHandlers={eventHandlerReports(embedConfig, reportingInstance, setLoading)}
            getEmbeddedComponent={(embedObject) => {
              reportingInstance.current = embedObject;
            }}
          />
        </div>
      )}
    </>
  );
};
